export default __webpack_public_path__ + "static/media/competition@2x.10ede261.svg";